import { routes } from "../../../routing/routes";

export function navigateToSettings(success?: boolean) {
  routes.go(routes.settings(success));
}
